/**
 * DefaultLayout.js - Default layout. This is used to build the default layout
 * of static pages when another more specialized layout cannot be used.
 *
 * @author Alex Symeonidis
 */
import React from "react"
import PrimaryMenu from "../components/PrimaryMenu";
import BreadcrumbBanner from "../components/BreadcrumbBanner";
import PrimaryFooter from "../components/PrimaryFooter";
import { withTrans } from "../i18n/withTrans";

function DefaultLayout({ title, crumbs, children }) {
  return <div>
    <div className='container'>
      <PrimaryMenu/>
    </div>
    {
      crumbs &&
      <BreadcrumbBanner title={title} crumbs={crumbs}/>
    }
    <div className='container-wrapper'>
      <div className='container'>
        { children }
      </div>
    </div>

    <PrimaryFooter/>
  </div>
}

export default withTrans(DefaultLayout);